import CancelIcon from 'assets/svg/cancel/cancel-icon.svg'
import CheckRoundIcon from 'assets/svg/check/check-round.svg'
import BusinessIcon from 'assets/svg/seller-icon/seller-illustration-lg.svg'
import Button from 'common/components/Button'
import Modal from 'common/components/Modal'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import styled from 'styled-components'

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const BenefitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
`

const BenefitItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

const GreenCheckIcon = styled(CheckRoundIcon)`
  path:last-child {
    fill: ${theme.colors.green};
  }
`

const TextButton = styled(Button)`
  background-color: transparent;
  color: ${theme.colors.orange};
  margin-top: 16px;
  height: fit-content;
`

const StyledCancelIcon = styled(CancelIcon)`
  position: absolute;
  right: 0;
  transform: scale(1.6);
  color: ${theme.colors.grayDark};
  :hover {
    transition: 0.3s;
    transform: scale(1.25);
    cursor: pointer;
  }
`

const BENEFITS = [
  'Meningkatkan kredibilitas dan legalitas usaha Anda',
  'Mempermudah akses permodalan di Ralali.com',
  'Meningkatkan peluang mendapatkan mitra bisnis',
]

const BUTTON_PROPS = {
  block: true,
  fontWeight: 'bold',
}

interface IModalNIBProps {
  isOpen: boolean
  onOverlayClick: () => void
  onContinueOpenStore: () => void
  onLearnRalaliConnect: () => void
}

function ModalNIB({
  isOpen,
  onOverlayClick,
  onContinueOpenStore,
  onLearnRalaliConnect,
}: IModalNIBProps): JSX.Element {
  return (
    <Modal
      padding="32px"
      height="fit-content"
      onOverlayClick={onOverlayClick}
      isOpen={isOpen}
    >
      <ContentWrapper>
        <StyledCancelIcon
          onClick={onOverlayClick}
          data-testid="cancel-icon"
        />
        <BusinessIcon />
        <Typography type="bh2" marginTop={24} marginBottom={16}>
          Buka Toko di Ralali.com
        </Typography>
        <Typography textAlign="center">
          Per tanggal 5 Mei 2023, kami mewajibkan kepada siapapun yang
          ingin membuka toko di Ralali Marketplace memiliki NIB (Nomor
          Induk Berusaha) berdasarkan peraturan pemerintah Perpres
          Nomor 91 Tahun 2017. Apabila
          <b> Anda tidak mempunyai NIB </b>
          Anda
          <b> tetap dapat berjualan dan bergabung </b>
          bersama para penjual UMKM kami melalui platform Ralali
          Connect
        </Typography>
        <Typography
          type="bparagraph"
          marginTop={24}
          marginBottom={16}
        >
          Mengapa Saya Membutuhkan NIB?
        </Typography>
        <BenefitWrapper>
          {BENEFITS.map((benefit) => (
            <BenefitItem key={benefit}>
              <GreenCheckIcon />
              <Typography>{benefit}</Typography>
            </BenefitItem>
          ))}
        </BenefitWrapper>
        <Button
          {...BUTTON_PROPS}
          fontSize="16px"
          height="54px"
          onClick={onContinueOpenStore}
        >
          Punya NIB, Lanjutkan Buka Toko
        </Button>
        <TextButton
          {...BUTTON_PROPS}
          fontSize="14px"
          onClick={onLearnRalaliConnect}
        >
          Tidak Punya NIB, Pelajari Ralali Connect
        </TextButton>
      </ContentWrapper>
    </Modal>
  )
}

export default ModalNIB
